import { Store } from '@ngrx/store'
import { ApiService } from '@api/api.service'
import { ActivatedRoute, Router } from '@angular/router'
import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { KeycloakService } from 'keycloak-angular'
import { environment } from 'src/environments/environment'
import { FooterObject } from 'src/environments/defaultEnvironment'
import { RootActions } from '../app.root.actions'
import { Subscriptions } from '../utils/subscriptions'
import { GroupsService } from '../groups/groups.service'
import { selectProfileState } from '../account/user-profile/user-profile.state'
import { CustomerInfoActions } from '../account/user-profile/user-profile.actions'
import {Observable} from "rxjs";

const allowedTranslationFeatures = ['manage-subscription']

@Component({
  selector: 'cover-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
})
export class NavBarComponent implements OnInit, OnDestroy {
  private readonly subscriptions: Subscriptions = new Subscriptions(true)

  firstName$: Observable<string | undefined>
  useMobileLayout: boolean = false
  c4SessionId: string = ''
  readonly environment = environment
  footerHeader: string | undefined
  leftFooterItems: FooterObject[] = []
  rightFooterItems: FooterObject[] = []
  isLoggedIn: boolean = false
  showTranslation: boolean = false
  linedFooter: boolean = environment.features.footer.lined

  logo: string = `${environment.realmId}/${environment.logo}`

  @ViewChild('logoutButton') logoutButton: any
  width: number = 0
  resizeObserver: ResizeObserver | undefined

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.useMobileLayout = !this.isGreaterThanExtraSmall()
  }

  constructor(
    private readonly keycloak: KeycloakService,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly store: Store,
    private readonly api: ApiService,
    private readonly groupsService: GroupsService,
  ) {
    this.firstName$ = store.select(selectProfileState.firstNameState)
    this.subscriptions.plusOne = store.select(selectProfileState.c4SessionId).subscribe(sessionId => {
      this.c4SessionId = sessionId
      this.checkPaymentMethods()
    })
  }

  ngOnInit(): void {
    this.isLoggedIn = this.keycloak.isLoggedIn()
    if (this.isLoggedIn) {
      this.keycloak.loadUserProfile().then(userProfile => {
        this.store.dispatch(
          CustomerInfoActions.c4LoginLoad({
            payload: { uuidAuthent: '' },
          }),
        )
        this.store.dispatch(
          RootActions.setKcAttributes({
            payload: {
              kcUuid: (userProfile as any)['attributes']['uuid'][0],
              kcEmail: userProfile.email!,
              kcFirstName: userProfile.firstName!,
              kcLastName: userProfile.lastName!,
            },
          }),
        )
      })
      this.scheduleTokenRefresh()
    }

    this.footerHeader = this.environment?.footer.header

    this.activatedRoute.url.subscribe(url => {
      for (let urlPath of url) {
        if (allowedTranslationFeatures.includes(urlPath.path)) this.showTranslation = true
      }
    })

    this.leftFooterItems = this.environment?.footer.leftFooter
    this.rightFooterItems = this.environment?.footer.rightFooter

    // this.subscriptions.plusOne = this.keycloak.keycloakEvents$
    //   .pipe(
    //     tap(result => {
    //       console.log(result)
    //     }),
    //   )
    //   .subscribe()
  }

  private scheduleTokenRefresh() {
    const keycloakInstance = this.keycloak.getKeycloakInstance()
    const refreshInterval = 900000

    this.keycloak.getKeycloakInstance()

    setInterval(() => {
      try {
        const refreshed = keycloakInstance.updateToken(900)
        if (refreshed) {
          console.debug('Token was successfully refreshed')
        } else {
          console.debug('Token is still valid')
        }
      } catch (e) {
        console.error('Failed to refresh the token, or the session has expired')
        this.keycloak.logout()
      }
    }, refreshInterval)

    this.useMobileLayout = !this.isGreaterThanExtraSmall()
  }

  isGreaterThanExtraSmall(): boolean {
    return window.innerWidth > 768
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()

    if (this.resizeObserver) {
      this.resizeObserver.unobserve(this.logoutButton._element.nativeElement)
    }
  }

  logout(): void {
    this.keycloak.logout()
  }

  changePassword(): void {
    this.keycloak.login({
      action: 'UPDATE_PASSWORD',
      redirectUri: window.location.href,
      // prompt: 'none' // todo: check if this helps in users not having to authenticate themselves again after a certain period
    })
  }

  redirectToOnlineSubscriptions(): void {
    this.api.redirectToOnlineSubscriptions()
  }

  redirectToExternalWebReader(): void {
    this.api.redirectToExternalWebReader()
  }

  checkPaymentMethods(): void {
    if (this.c4SessionId) {
      this.store.dispatch(
        CustomerInfoActions.paymentMethodsLoad({
          payload: {
            sessionId: this.c4SessionId,
          },
        }),
      )
    }
  }

  switchToLanguage(symbol: string): void {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { lang: symbol },
      queryParamsHandling: 'merge',
    })
  }
}
